module.exports = __webpack_public_path__ + "img/TTD.8b6786cf.svg";